export default __webpack_public_path__ + "static/mmr-502756380d2339a1f4ba747ca2ab3404.png";